/* External */
import { useMemo } from 'react';

/* Utils */
import {
  getFirstGenre,
  getFormattedDuration,
  useFullEpisodeName,
  getRating,
  isEpisode,
  isMovie,
  joinArrayWithSeparator,
  joinArrayWithSpace,
} from '../../utils/metaDataUtils';

export function useSubtitleContinueWatching(content) {
  const fullEpisodeName = useFullEpisodeName(content);
  return useMemo(() => {
    if (isEpisode(content)) {
      return joinArrayWithSpace([
        getRating(content),
        fullEpisodeName,
      ]);
    }

    return joinArrayWithSpace([
      getRating(content),
      joinArrayWithSeparator([
        getFirstGenre(content),
        isMovie(content) && content?.releaseYear,
        isMovie(content) && getFormattedDuration(content),
      ]),
    ]);
  }, [content, fullEpisodeName]);
}
